import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserAccountSetting = () => {
  const userId = localStorage.getItem("userId");

  const [postaccount, setPostAccount] = useState({
    userId: userId,
    userName: "",
    email: "",
    languagesKnown: [],
  });

  // ✅ Get Account Setting
  const getAcccountSetting = async () => {
    try {
      const response = await axios.post(webServiceUrl.getAccountSettings, {
        userId: userId,
      });
      const data = response.data;

      setPostAccount({
        userId: userId,
        userName: data.userName || "",
        email: data.email || "",
        languagesKnown: data.languagesKnown || [],
      });
    } catch (error) {
      toast.error(error.message || "Failed to load account settings.");
    }
  };

  // ✅ Handle change for text inputs
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setPostAccount({ ...postaccount, [id]: value });
  };

  // ✅ Handle checkbox change
  const handleLanguageChange = (e) => {
    const { id, checked } = e.target;
    let updatedLanguages = [...postaccount.languagesKnown];

    if (checked) {
      updatedLanguages.push(id);
    } else {
      updatedLanguages = updatedLanguages.filter((lang) => lang !== id);
    }

    setPostAccount({ ...postaccount, languagesKnown: updatedLanguages });
  };

  // ✅ Post Account Setting
  const postAccountData = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        webServiceUrl.postAccountSettings,
        postaccount
      );
      if (response.data.success) {
        toast.success("Account settings updated successfully!");
        getAcccountSetting(); // Refresh after update
      } else {
        toast.error(response.data.message || "Failed to update settings.");
      }
    } catch (error) {
      toast.error("Network Error");
    }
  };

  useEffect(() => {
    getAcccountSetting();
  }, []);

  const languageOptions = [
    "English",
    "French",
    "Hindi",
    "Spanish",
    "Arabic",
    "Italian",
  ];

  return (
    <>
      <div className="content-inner">
        <Container>
          <Row>
            <Col lg="6">
              <Card>
                <Card.Header className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Account Setting</h4>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="acc-edit">
                    <Form onSubmit={postAccountData}>
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="userName" className="form-label">
                          User Name:
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="userName"
                          value={postaccount.userName}
                          onChange={handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group className="form-group">
                        <Form.Label htmlFor="email" className="form-label">
                          Email Id:
                        </Form.Label>
                        <Form.Control
                          type="email"
                          id="email"
                          value={postaccount.email}
                          onChange={handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group className="form-group">
                        <Form.Label className="d-block form-label">
                          Language Known:
                        </Form.Label>
                        {languageOptions.map((lang) => (
                          <Form.Check
                            key={lang}
                            className="form-check form-check-inline"
                          >
                            <Form.Check.Input
                              type="checkbox"
                              id={lang}
                              checked={postaccount.languagesKnown.includes(
                                lang
                              )}
                              onChange={handleLanguageChange}
                            />
                            <Form.Check.Label
                              className="form-check-label"
                              htmlFor={lang}
                            >
                              {lang}
                            </Form.Check.Label>
                          </Form.Check>
                        ))}
                      </Form.Group>

                      <Button type="submit" className="btn btn-primary me-2">
                        Submit
                      </Button>
                      <button
                        type="reset"
                        className="btn btn-danger-subtle"
                        onClick={getAcccountSetting}
                      >
                        Cancel
                      </button>
                    </Form>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </>
  );
};

export default UserAccountSetting;

// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const UserAccountSetting = () => {
//   const userId = localStorage.getItem("userId");

//   const [getaccount, setGetAccount] = useState({});

//   const [postaccount, setPostAccount] = useState({
//     userId: userId,
//     userName: "",
//     email: "",
//     languagesKnown: [],
//   });

//   // Get Account setting
//   const getAcccountSetting = async () => {
//     try {
//       const response = await axios.post(webServiceUrl.getAccountSettings, {
//         userId: userId,
//       });

//       console.log(response.data, "response from getaccount setting");
//       setGetAccount(response.data);
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // post Account Setting
//   const postAccountData = async () => {
//     try {
//       const response = await axios.post(
//         webServiceUrl.postAccountSettings,
//         postaccount
//       );
//       console.log(response.data);
//     } catch (error) {
//       toast.error("Network Error");
//     }
//   };
//   useEffect(() => {
//     getAcccountSetting();
//   }, []);
//   return (
//     <>
//       <div className="content-inner">
//         <Container>
//           <Row>
//             <Col lg="6">
//               <Card>
//                 <Card.Header className="card-header d-flex justify-content-between">
//                   <div className="header-title">
//                     <h4 className="card-title">Account Setting</h4>
//                   </div>
//                 </Card.Header>
//                 <Card.Body>
//                   <div className="acc-edit">
//                     <Form>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="uname" className="form-label">
//                           User Name:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="uname"
//                           defaultValue="Bni@01"
//                         />
//                       </Form.Group>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="email" className="form-label">
//                           Email Id:
//                         </Form.Label>
//                         <Form.Control
//                           type="email"
//                           className="form-control"
//                           id="email"
//                           defaultValue="Bnijohn@gmail.com"
//                         />
//                       </Form.Group>
//                       {/* <Form.Group className="form-group">
//                         <Form.Label htmlFor="altemail" className="form-label">
//                           Alternate Email:
//                         </Form.Label>
//                         <Form.Control
//                           type="email"
//                           className="form-control"
//                           id="altemail"
//                           defaultValue="designtheme@gmail.com"
//                         />
//                       </Form.Group> */}
//                       <Form.Group className="form-group">
//                         <Form.Label className="d-block form-label">
//                           Language Known:
//                         </Form.Label>
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="english"
//                             defaultChecked
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="english"
//                           >
//                             English
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="french"
//                             defaultChecked
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="french"
//                           >
//                             French
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="hindi"
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="hindi"
//                           >
//                             Hindi
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="spanish"
//                             defaultChecked
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="spanish"
//                           >
//                             Spanish
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="arabic"
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="arabic"
//                           >
//                             Arabic
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                         <Form.Check className="form-check form-check-inline">
//                           <Form.Check.Input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="italian"
//                           />
//                           <Form.Check.Label
//                             className="form-check-label"
//                             htmlFor="italian"
//                           >
//                             Italian
//                           </Form.Check.Label>
//                         </Form.Check>{" "}
//                       </Form.Group>
//                       <Button type="submit" className="btn btn-primary me-2">
//                         Submit
//                       </Button>{" "}
//                       <button type="reset" className="btn btn-danger-subtle">
//                         Cancel
//                       </button>
//                     </Form>
//                   </div>
//                 </Card.Body>
//               </Card>
//             </Col>
//             {/* <Col lg="6">
//               <Card>
//                 <Card.Header className="card-header d-flex justify-content-between">
//                   <div className="header-title">
//                     <h4 className="card-title">Social Media</h4>
//                   </div>
//                 </Card.Header>
//                 <Card.Body>
//                   <div className="acc-edit">
//                     <Form>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="facebook" className="form-label">
//                           Facebook:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="facebook"
//                           defaultValue="www.facebook.com"
//                         />
//                       </Form.Group>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="twitter" className="form-label">
//                           Twitter:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="twitter"
//                           defaultValue="www.twitter.com"
//                         />
//                       </Form.Group>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="google" className="form-label">
//                           Google +:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="google"
//                           defaultValue="www.google.com"
//                         />
//                       </Form.Group>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="instagram" className="form-label">
//                           Instagram:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="instagram"
//                           defaultValue="www.instagram.com"
//                         />
//                       </Form.Group>
//                       <Form.Group className="form-group">
//                         <Form.Label htmlFor="youtube" className="form-label">
//                           You Tube:
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           className="form-control"
//                           id="youtube"
//                           defaultValue="www.youtube.com"
//                         />
//                       </Form.Group>
//                       <Button type="submit" className="btn btn-primary me-2">
//                         Submit
//                       </Button>{" "}
//                       <button type="reset" className="btn btn-danger-subtle">
//                         Cancel
//                       </button>
//                     </Form>
//                   </div>
//                 </Card.Body>
//               </Card>
//             </Col> */}
//           </Row>
//         </Container>

//         {/* 🔔 ToastContainer */}
//         <ToastContainer
//           position="top-right"
//           autoClose={3000}
//           style={{ fontSize: "15px" }}
//         />
//       </div>
//     </>
//   );
// };

// export default UserAccountSetting;
